{
  "name": "heroui-cli",
  "private": false,
  "type": "module",
  "license": "MIT",
  "version": "3.0.2",
  "homepage": "https://github.com/heroui-inc/heroui-cli#readme",
  "description": "A CLI tool that unlocks seamless HeroUI integration",
  "keywords": [
    "UI",
    "CLI",
    "Tool",
    "Template",
    "Integration",
    "Add Component",
    "HeroUI"
  ],
  "author": {
    "name": "HeroUI",
    "email": "support@heroui.com",
    "url": "https://github.com/heroui-inc"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/heroui-inc/heroui-cli.git"
  },
  "bugs": {
    "url": "https://github.com/heroui-inc/heroui-cli/issues"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "files": [
    "dist"
  ],
  "bin": {
    "heroui": "./dist/index.js"
  },
  "main": "./dist/index.js",
  "module": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "scripts": {
    "dev": "tsup --watch",
    "link:cli": "pnpm link --global",
    "link:remove": "pnpm uninstall --global heroui-cli",
    "build": "tsup",
    "sync:docs": "tsx src/scripts/sync/sync.ts",
    "clean:cache": "tsx src/scripts/cache/clean.ts",
    "lint": "eslint . --max-warnings=0",
    "lint:fix": "eslint . --max-warnings=0 --fix",
    "check:prettier": "prettier --check .",
    "check:types": "tsc --noEmit",
    "changelog": "npx conventional-changelog -p angular -i CHANGELOG.md -s --commit-path .",
    "release": "bumpp --execute='pnpm run changelog' --all",
    "prepare": "husky install",
    "prepublishOnly": "pnpm run build"
  },
  "dependencies": {
    "@clack/prompts": "1.1.0",
    "@winches/prompts": "0.0.7",
    "async-retry": "1.3.3",
    "chalk": "5.6.2",
    "commander": "14.0.3",
    "compare-versions": "6.1.1",
    "fast-glob": "3.3.3",
    "find-up": "8.0.0",
    "gradient-string": "2.0.2",
    "ora": "8.2.0",
    "pathe": "2.0.3",
    "posthog-node": "5.28.4",
    "tar": "7.5.12"
  },
  "devDependencies": {
    "@commitlint/cli": "19.5.0",
    "@commitlint/config-conventional": "19.5.0",
    "@types/gradient-string": "1.1.6",
    "@types/node": "20.19.28",
    "@typescript-eslint/eslint-plugin": "6.21.0",
    "@typescript-eslint/parser": "6.21.0",
    "bumpp": "10.3.2",
    "clean-package": "2.2.0",
    "commitlint-plugin-function-rules": "4.3.0",
    "conventional-changelog-cli": "5.0.0",
    "eslint": "8.57.1",
    "eslint-config-prettier": "9.1.2",
    "eslint-import-resolver-typescript": "3.10.1",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-prettier": "5.5.4",
    "eslint-plugin-sort-destructure-keys": "1.6.0",
    "eslint-plugin-sort-keys-fix": "1.1.2",
    "eslint-plugin-unicorn": "52.0.0",
    "eslint-plugin-unused-imports": "3.2.0",
    "husky": "9.1.7",
    "lint-staged": "16.2.7",
    "prettier": "3.7.4",
    "tsup": "8.5.1",
    "tsx": "4.21.0",
    "typescript": "5.9.3"
  },
  "engines": {
    "node": ">=22.22.0",
    "pnpm": ">=10.x"
  },
  "packageManager": "pnpm@10.26.2"
}
